import { TeaserEntry } from "../helper/interfaces";
import React, { useContext } from "react";
import {
  Mic,
  Image,
  Video,
  Film,
  Coffee,
  Truck,
  Smartphone,
  Droplet,
  Calendar,
  Volume,
  Radio
} from "react-feather";

import { AppTheme, ContentType } from "../helper/enums";
import TeaserAdMarker from "./teaserAdMarker";

export interface TeaserData {
  teaser: TeaserEntry;
}

function TeaserInfos(data: TeaserData) {
  const teaser = data.teaser;
  const IconGallery = () => (
    <svg
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      aria-labelledby="icon-gallery"
    >
      <title id="icon-gallery">Gallery Icon</title>
      <path
        d="M765.952 749.056h-540.672c-10.24 0-16.384-8.192-16.384-16.384v-540.672h-61.44v540.672c0 43.008 34.816 77.824 77.824 77.824h540.672v-61.44zM876.544 671.232v-534.528c0-28.672-22.528-51.2-51.2-51.2h-534.528c-28.672 0-51.2 22.528-51.2 51.2v534.528c0 28.672 22.528 51.2 51.2 51.2h534.528c28.672 0 51.2-22.528 51.2-51.2zM806.912 656.896h-497.664v-442.368h497.664v442.368zM450.56 423.424c24.576 0 45.056 8.192 61.44 26.624 16.384 16.384 26.624 36.864 26.624 61.44s-8.192 45.056-26.624 61.44c-16.384 16.384-36.864 26.624-61.44 26.624s-45.056-8.192-61.44-24.576c-16.384-16.384-24.576-36.864-26.624-61.44v0c0-24.576 8.192-45.056 26.624-61.44 16.384-20.48 36.864-28.672 61.44-28.672zM458.752 368.128c-8.192 8.192-18.432 12.288-32.768 12.288-12.288 0-24.576-4.096-32.768-12.288l-55.296-55.296v-63.488h237.568l-116.736 118.784zM638.976 249.344h137.216v129.024l-77.824 77.824c-8.192 8.192-18.432 12.288-32.768 12.288s-24.576-4.096-32.768-12.288l-100.352-102.4 106.496-104.448z"
        fill="currentColor"
      />
    </svg>
  );
  return (
    <React.Fragment>
      {(teaser.paid || teaser.ressort || teaser.topline || teaser.adIdentifier) && (
        <div className="teaser-info">
          <TeaserAdMarker adIdentifier={teaser.adIdentifier} />
          {teaser.paid && !teaser.hidePlusIcon && <div className="icon-nnplus" aria-label="NN+"></div>}
          {process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nb &&
            (teaser.ressort || teaser.subline) && (
              <div className="teaser-ressort">
                {teaser.ressort}
                {teaser.ressort && teaser.subline && " | "}
                {teaser.subline && (
                  <span className="teaser-date">{teaser.subline}</span>
                )}
              </div>
            )}
          {process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nb &&
            teaser.type !== ContentType.Podcast && (
              <>
                {teaser.topline && (
                  <div className="teaser-topline">
                    <div>{teaser.topline}</div>
                  </div>
                )}
              </>
            )}

          {(teaser.topline &&
            process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nb) ||
            (process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn &&
              teaser.type === ContentType.Podcast && (
                <div className="teaser-topline">{teaser.topline}</div>
              ))}
          <div>
            {teaser.teaserTypes && teaser.teaserTypes.length > 0 &&
              teaser.type != ContentType.Podcast &&
              process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn && (
                <div className="teaser__image__icons">
                  {teaser.teaserTypes.map((icon, index) => {
                    switch (icon) {
                      case "video":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-video-${icon}-${index}-${teaser.id}`}>
                            <Video />
                          </div>
                        );
                        break;
                      case "audio":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-audio-${icon}-${index}-${teaser.id}`}>
                            <Mic />
                          </div>
                        );
                        break;
                      case "event":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-event-${icon}-${index}-${teaser.id}`}>
                            <Calendar />
                          </div>
                        );
                        break;
                      case "gallery":
                        return (
                          <div className="teaser__image__icon icon-gallery" key={`icon-gallery-${icon}-${index}-${teaser.id}`}>
                            <IconGallery />
                          </div>
                        );
                        break;
                      case "gastro":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-gastro-${icon}-${index}-${teaser.id}`}>
                            <Coffee />
                          </div>
                        );
                        break;
                      case "liveticker":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-liveticker-${icon}-${index}-${teaser.id}`}>
                            <Radio />
                          </div>
                        );
                        break;
                      case "movie":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-movie-${icon}-${index}-${teaser.id}`}>
                            <Film />
                          </div>
                        );
                        break;
                      case "moviedate":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-moviedate-${icon}-${index}-${teaser.id}`}>
                            <Film />
                          </div>
                        );
                        break;
                      case "dailymotionvideo":
                        return (
                          <div className="teaser__image__icon icon-category" key={`icon-dailymotionvideo-${icon}-${index}-${teaser.id}`}>
                            <Film />
                          </div>
                        );
                        break;
                      default:
                        return <></>;
                        break;
                    }
                  })}
                </div>
              )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default TeaserInfos;
